import React from 'react';
import { useTranslation } from 'react-i18next';

import { validateEmail } from '../../../utils/validation';
import ButtonStyled from '../button/Button';
import { Modal } from '../modal/Modal';
import styles from './modalSendEmailDirections.module.scss';

type ModalSendEmailDirectionsProps = {
  onSubmit: (email: string) => void;
  isOpen: boolean;
  onClose: () => void;
};

const ModalSendEmailDirections: React.FC<ModalSendEmailDirectionsProps> = ({
  isOpen,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation('common');
  const [email, setEmail] = React.useState('');

  const handleOnClose = () => {
    setEmail('');
    onClose();
  };

  const handleSubmit = (email: string) => {
    onSubmit(email);
    handleOnClose();
  };

  return (
    <Modal isOpen={isOpen}>
      <div className={styles.emailModal}>
        <h2 className={styles.title}>
          {t('campusNavigation.share.email.title')}
        </h2>
        <p className={styles.description}>
          {t('campusNavigation.share.email.description')}
        </p>
        <div className={styles.emailContent}>
          <label htmlFor="email" className={styles.label}>
            {t('campusNavigation.share.email.label')}
          </label>
          <input
            id="email"
            type="text"
            placeholder={t('campusNavigation.share.email.label')}
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            className={styles.input}
            autoComplete="off"
          />
        </div>
        <div className={styles.emailButtons}>
          <ButtonStyled
            onClick={handleOnClose}
            variant={'outlined'}
            className={styles.button}
            uppercase
          >
            {t('labels.cancel')}
          </ButtonStyled>
          <ButtonStyled
            onClick={() => handleSubmit(email)}
            disabled={!validateEmail(email)}
            className={styles.button}
            uppercase
          >
            {t('campusNavigation.share.email.send')}
          </ButtonStyled>
        </div>
      </div>
    </Modal>
  );
};

export default ModalSendEmailDirections;
